export default __webpack_public_path__ + "static/media/cheers.92f2ae65.svg";